import { GAL_EDITIONS } from '../data/galEditions';
import HEBREW_EDITIONS from '../data/hebrewEditions.json';
import GREEK_EDITIONS from '../data/greekEditions.json';
import LATIN_EDITIONS from '../data/latinEditions.json';

export function originalType(book) {
  if (Object.prototype.hasOwnProperty.call(HEBREW_EDITIONS, book)) return 'hebrew';
  if (Object.prototype.hasOwnProperty.call(GREEK_EDITIONS, book)) return 'greek';
  return null;
}

export function editionForBook(type, book) {
  if (type === 'original') return originalType(book);
  if (type === 'gal' && !Object.prototype.hasOwnProperty.call(GAL_EDITIONS, book)) return null;
  if (type === 'latin' && !Object.prototype.hasOwnProperty.call(LATIN_EDITIONS, book)) return null;
  return type;
}

export function editionOptions(pathname) {
  const isHome = pathname === '/';
  const book = pathname.startsWith('/bible/') ? pathname.split('/')[2] : '';
  const options = [
    { value: 'norm', label: '日本語', shortLabel: '日本語' },
    { value: 'ruby', label: 'かな・ふりがな', shortLabel: 'かな' },
    { value: 'en', label: 'English', shortLabel: 'English' },
  ];
  if (isHome || Object.prototype.hasOwnProperty.call(GAL_EDITIONS, book)) {
    options.push({ value: 'gal', label: 'ギャル訳', shortLabel: 'ギャル' });
  }
  const original = isHome ? 'original' : originalType(book);
  if (original) {
    options.push({ value: original, label: original === 'hebrew' ? '原語・ヘブライ語' : original === 'greek' ? '原語・ギリシャ語' : '原語', shortLabel: '原語' });
  }
  if (isHome || Object.prototype.hasOwnProperty.call(LATIN_EDITIONS, book)) {
    options.push({ value: 'latin', label: 'ラテン語', shortLabel: 'ラテン語' });
  }
  return options;
}
